import React from 'react';
import { HorizontalBar } from 'react-chartjs-2';


const ChartDataModal = ({ data, legendItem }) => {
    const item = legendItem.text.substr(0, legendItem.text.indexOf('(') - 1);
    const extractedData = data.filter(el => el.subCategory === item)[0].Threats;

    const chartData = {
        labels: extractedData.map(el => el.threat),
        datasets: [
            {
                label: 'Date',
                backgroundColor: 'rgba(255,99,132,0.2)',
                borderColor: 'rgba(255,99,132,1)',
                borderWidth: 1,
                hoverBackgroundColor: 'rgba(255,99,132,0.4)',
                hoverBorderColor: 'rgba(255,99,132,1)',
                data: extractedData.map(el => el.count)
            }
        ]
    }

    return (
        <div>
            <HorizontalBar
                data={chartData}
                // height={100}
                plugins={['ChartDataLabels']}
                options={{
                    legend: {
                        display: false
                    },
                    scales: {
                        xAxes: [{
                            offset: true,
                        }]
                    },
                    plugins: {
                        // Change options for ALL labels of THIS CHART
                        datalabels: {
                            color: 'grey',
                            anchor: 'end',
                            align: 'end',
                        }
                    },
                    layout: {
                        padding: {
                            left: 10
                        }
                    }
                }}
            />
        </div>
    );
}

export default ChartDataModal
